import { render, staticRenderFns } from "./video_play.vue?vue&type=template&id=5a69d2fc&"
import script from "./video_play.vue?vue&type=script&lang=js&"
export * from "./video_play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports